module.exports = __webpack_public_path__ + "static/media/push-up.86f5ee97.mp4";